import { useState } from "react";

const faqList = [
  {
    question: "爆料官网的「今日发布」内容多久更新一次？",
    answer:
      "今日发布频道每天固定更新两次，分别在上午 08:00 与晚间 20:00 前后。遇到重大事件时，编辑部会增设临时更新，最新动态栏目会实时同步。",
  },
  {
    question: "网站上的爆料内容都经过核实吗？",
    answer:
      "编辑部对每条内容执行至少两个独立信源的交叉核对，并在正文中标注信息来源类型。对尚未获得当事方回应的部分，会明确写出「截至发稿」的说明，避免读者将传闻当作结论。",
  },
  {
    question: "如果内容与事实不符，可以申请更正吗？",
    answer:
      "可以。当事方可通过页面底部的联系邮箱提交更正申请，附上相关说明与佐证材料。编辑部会在三个工作日内完成复核，确认后第一时间更正、补充说明或撤下相关段落。",
  },
  {
    question: "普通用户如何向爆料官网提供线索？",
    answer:
      "可通过「关于我们」页面下方的线索投稿表单提交。建议同时说明事件时间、涉及范围与已有的图片或材料线索，方便编辑部判断优先核实顺序。",
  },
  {
    question: "为什么评论区强调「理性吃瓜」？",
    answer:
      "爆料内容常涉及个人隐私与正在进行的事件，情绪化表达容易放大误解。我们希望讨论聚焦在事实与公开信息本身，遇到未经证实的细节时，先保留判断。",
  },
  {
    question: "内容会被用于商业用途吗？",
    answer:
      "不会。站内内容仅用于资讯传播，转载需注明出处并保留原文链接。涉及第三方图片与素材的，会按权利人要求及时处理。",
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full bg-background-100 py-10 md:py-12" aria-labelledby="faq-heading">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="mb-6 border-b border-background-200 pb-4">
          <p className="mb-2 flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
            <span className="h-3 w-1 rounded-full bg-primary-500"></span>
            FAQ
          </p>
          <h2 id="faq-heading" className="font-heading text-2xl font-bold text-foreground-950 md:text-[28px]">
            常见问题
          </h2>
          <p className="mt-2 font-body text-sm leading-6 text-foreground-600">
            关于内容来源、更新节奏与投稿方式的说明，先看这里再浏览。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-3">
          {faqList.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.question} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                      {item.question}
                    </span>
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center text-secondary-600">
                      <i className={isOpen ? "ri-subtract-line text-lg" : "ri-add-line text-lg"} aria-hidden="true"></i>
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <p className="border-t border-background-200 px-5 py-4 font-body text-sm leading-7 text-foreground-600">
                    {item.answer}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}